import { createAction, props } from "@ngrx/store";
import { User } from "../interfaces/State/User/user";

export const login = createAction('login')
export const logout = createAction('logout')
export const setUser = createAction('setUser', props<{user: User}>())